
// Test data for Level 1 Chipping Training

export const chippingTests = [
  {
    id: "chipping-plat",
    title: "Chipping balle levée sur terrain plat",
    description: "Positionner les balles pour les distances G=20, H=30, I=40 m (wedge de 60°, 56°, et 52°), jouer 10 balles et compter les points selon le cercle d'arrivée",
    icon: "⛳"
  },
  {
    id: "chipping-pente-droit",
    title: "Chipping balle levée Pente droite gauche",
    description: "Positionner les balles pour les distances G1=20, H1=30, I1=40 m (wedge de 60°, 56°, et 52°) prêt d'un green en pente, jouer 10 balles et compter les points selon le cercle d'arrivée",
    icon: "⛳"
  },
  {
    id: "chipping-roulee-plat",
    title: "Chipping balle roulée terrain plat",
    description: "Positionner les balles pour les distances G2=10, H2=20, I2=30 m (fer 7 à 9), jouer 10 balles et compter les points selon le cercle d'arrivée",
    icon: "⛳"
  }
];
